import { render, staticRenderFns } from "./CustomerChanger.vue?vue&type=template&id=5f744b52&scoped=true&"
import script from "./CustomerChanger.vue?vue&type=script&lang=js&"
export * from "./CustomerChanger.vue?vue&type=script&lang=js&"
import style0 from "./CustomerChanger.vue?vue&type=style&index=0&id=5f744b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f744b52",
  null
  
)

export default component.exports